export enum ErrorLevel {
    ERROR = 'ERROR',
    WARNING = 'WARNING',
    INFO = 'INFO'
  }
  